import { request, requestImage } from '../../utils'
import { HttpMethods } from '../../utils/apiHelper'
import { TYPE_EMAIL, TYPE_PHONE } from '../../utils/entities/studentExtraInfo'

const INITIAL_STATE = {
  studentInformations: {},
  studentExtraInformations: {},
  studentPrivacyInformations: {},
  studentProfileImage: ''
}

const SET_STUDENT_INFORMATIONS = 'SET_STUDENT_INFORMATIONS'
const SET_STUDENT_EXTRA_INFORMATIONS = 'SET_STUDENT_EXTRA_INFORMATIONS'
const SET_STUDENT_PRIVACY_INFORMATIONS = 'SET_STUDENT_PRIVACY_INFORMATIONS'
const SET_STUDENT_PROFILE_IMAGE = 'SET_STUDENT_PROFILE_IMAGE'
const REMOVE_STUDENT_PROFILE_IMAGE = 'REMOVE_STUDENT_PROFILE_IMAGE'

export const getProfileData = (state) => {
  return state
}

export const getStudentInformations = (state) => {
  return state.studentInformations
}

export const getStudentExtraInformations = (state) => {
  return state.studentExtraInformations
}

export const getStudentProfileImage = (state) => {
  return state.studentProfileImage
}

export const fetchStudentExtraInformations = (user) => {
  return async function fetchStudentExtraInformationsThunk (dispatch, getState) {
    const response = await request(
      '/student/get-additional-contact-info',
      HttpMethods.GET,
      null,
      user
    )

    const studentExtraInformations = {
      emails: [],
      phones: []
    }

    response.data.forEach(extraInfo => {
      if (extraInfo.type === TYPE_EMAIL) {
        studentExtraInformations.emails.push(extraInfo.value)
      } else if (extraInfo.type === TYPE_PHONE) {
        studentExtraInformations.phones.push(extraInfo.value)
      }
    })

    dispatch({ type: SET_STUDENT_EXTRA_INFORMATIONS, payload: studentExtraInformations })
  }
}

export const fetchStudentProfileImage = (imageName, user) => {
  return async function fetchStudentProfileImageThunk (dispatch, getState) {
    const response = await requestImage(
      '/profil/image/' + imageName,
      HttpMethods.GET,
      null,
      user
    )

    dispatch({ type: SET_STUDENT_PROFILE_IMAGE, payload: response })
  }
}

export const setStudentInformations = (studentInformations) => {
  return {
    type: SET_STUDENT_INFORMATIONS,
    payload: studentInformations
  }
}

export const setStudentExtraInformations = (studentExtraInformations) => {
  return {
    type: SET_STUDENT_EXTRA_INFORMATIONS,
    payload: studentExtraInformations
  }
}

export const setStudentPrivacyInformations = (studentPrivacyInformations) => {
  return {
    type: SET_STUDENT_PRIVACY_INFORMATIONS,
    payload: studentPrivacyInformations
  }
}

export const setStudentProfileImage = (studentProfileImage) => {
  return {
    type: SET_STUDENT_PROFILE_IMAGE,
    payload: studentProfileImage
  }
}

export const removeStudentProfileImage = () => {
  return {
    type: REMOVE_STUDENT_PROFILE_IMAGE
  }
}

/**
 * Reducer for the profile informations
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_STUDENT_INFORMATIONS: {
      return { ...state, studentInformations: action.payload }
    }
    case SET_STUDENT_EXTRA_INFORMATIONS: {
      return { ...state, studentExtraInformations: action.payload }
    }
    case SET_STUDENT_PRIVACY_INFORMATIONS: {
      return { ...state, studentPrivacyInformations: action.payload }
    }
    case SET_STUDENT_PROFILE_IMAGE: {
      return { ...state, studentProfileImage: action.payload }
    }
    case REMOVE_STUDENT_PROFILE_IMAGE: {
      const studentImage = state.studentProfileImage

      URL.revokeObjectURL(studentImage)

      return { ...state, studentProfileImage: '' }
    }
    default:
      return state
  }
}
